var _defs, _rect, _path, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".st-accent{fill:#ed0000;}.st-plate{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st-plate",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3.54,
    ry: 3.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 37V11h3v23h25v3H10Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 4.5,
    height: 9,
    rx: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 18,
    width: 4.5,
    height: 15,
    rx: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 12,
    width: 4.5,
    height: 21,
    rx: 0.8,
    className: "st-accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.896adec30ed4255af2c32d4a3b4eba31.svg";
export { ForwardRef as ReactComponent };